import * as typeChecker from 'type-check';
import { ComplexTypeEnum } from './complex-type-enum.js';
import { PrimitiveTypeEnum } from './primitive-type-enum.js';
const { typeCheck } = typeChecker;
export class TypeHelper {
    static isNil(value) {
        const is = typeCheck(`${PrimitiveTypeEnum.null} | ${PrimitiveTypeEnum.undefined}`, value);
        return is;
    }
    static isString(value) {
        const is = typeCheck(PrimitiveTypeEnum.string, value);
        return is;
    }
    static isNumber(value) {
        const is = typeCheck(PrimitiveTypeEnum.number, value);
        return is;
    }
    static isBoolean(value) {
        const is = typeCheck(PrimitiveTypeEnum.boolean, value);
        return is;
    }
    static isPrimitiveTypes(value, ...types) {
        const condition = types.join(' | ');
        const is = typeCheck(condition, value);
        return is;
    }
    static isObject(value) {
        const is = typeCheck(ComplexTypeEnum.object, value);
        return is;
    }
    static isEmptyObject(value) {
        const is = this.isObject(value) && Object.keys(value).length === 0;
        return is;
    }
    static isArray(value) {
        const is = typeCheck(ComplexTypeEnum.array, value);
        return is;
    }
    static isEmptyArray(value) {
        const is = this.isArray(value) && value.length === 0;
        return is;
    }
    static isValidArray(value) {
        const is = this.isArray(value) && !this.isEmptyArray(value);
        return is;
    }
    static isPrimitiveTypesArray(value, ...type) {
        const condition = type.join(' | ');
        const is = typeCheck(`[${condition}]`, value);
        return is;
    }
    static isGivenType(value, type, options) {
        const is = typeCheck(type, value, options);
        return is;
    }
}
//# sourceMappingURL=type-helper.js.map